<ng-container *ngIf="!infoLoaded">
	<app-loading aria-live="polite" [attr.aria-label]="'createAccountSidebar.upgrade.aria.loadingDialog' | ibeadmin | async"></app-loading>
</ng-container>

<ng-container *ngIf="infoLoaded">

	<div class="sidebar">
		<div class="loader_container__overlay" *ngIf="isLoading">
			<div class="loading-wrapper">
				<app-loading></app-loading>		
			</div>
		</div>

		<app-sidebar-header [title]="'createAccountSidebar.upgrade.title.upgradeToMilesGo' | ibeadmin | async">
		</app-sidebar-header>

		<!--
		<app-sidebar-header [title]="'createAccountSidebar.upgrade.title.upgradeToMilesGo' | ibeadmin | async" [confirmation$]="hasChanges$">
			<div actions *ngIf="hasChanges$ | async">
				<button class="button button--small" (click)="INDRA_saveSidebar()">
					{{'createAccountSidebar.upgrade.text.save' | ibeadmin | async}}
				</button>
			</div>
		</app-sidebar-header>
		-->

		<div #sidebar class="sidebar__body sl--scrollable" #sidebar__body>

			<div class="block-image hidden-mobile">
				<img src="assets/images/banner_milesgo.svg" alt="Miles&GO banner image" />
			</div>

			<p>
				{{'createAccountSidebar.upgrade.text.becomeFrequentFlyer' | ibeadmin | async}}
				<br><a class="link link--external" target="_blank" href="https://www.flytap.com/pt-pt/termos-e-condicoes-miles-and-go" [attr.aria-label]="'createAccountSidebar.upgrade.aria.termsCondition' | ibeadmin | async">{{'createAccountSidebar.upgrade.text.learnMoreMilesGo' | ibeadmin | async}}</a>
			</p>

			<app-notification (closeNotif)="INDRA_close($event)" *ngIf="showError" [style]="'alert'" [icon]="'icons.svg#airport--delays'" [close]="true"
				[title]="'createAccountSidebar.upgrade.title.notPossibleToUpgrade' | ibeadmin | async">
				<div message>
					<span>{{ errorMessage }}</span> <br />
				</div>
			</app-notification>

			<hr class="separator" aria-hidden="true">
			<div class="title-h2 top-gap">
				{{'createAccountSidebar.upgrade.text.youWillKeep' | ibeadmin | async}}
			</div>

			<form (ngSubmit)="INDRA_saveSidebar()" [formGroup]="form">

				<div class="form--view-mode">
					<div class="form-field--row grid no-padding">
						<div class="form-field col-4 col-tp-4 col-p-4">
							<span class="label">{{'createAccountSidebar.upgrade.text.title' | ibeadmin | async}}</span>
							<span class="value">{{ INDRA_printPassengerTitle() }}</span>
						</div>
						<div class="form-field col-4 col-tp-4 col-p-4">
							<span class="label">{{'createAccountSidebar.upgrade.text.firstName' | ibeadmin | async}}</span>
							<span class="value">{{ userInfo?.firstName }}</span>
						</div>
						<div class="form-field col-4 col-tp-4 col-p-4">
							<span class="label">{{'createAccountSidebar.upgrade.text.lastName' | ibeadmin | async}}</span>
							<span class="value">{{ userInfo?.lastName }}</span>
						</div>
					</div>
					<div class="form-field--row grid no-padding">
						<div class="form-field col-4 col-tp-4 col-p-4">
							<span class="label">{{'createAccountSidebar.upgrade.text.phoneType' | ibeadmin | async}}</span>
							<span class="value">{{ INDRA_printPhoneType() }}</span>
						</div>
						<div class="form-field col-8 col-tp-8 col-p-8">
							<span class="label">{{'createAccountSidebar.upgrade.text.phoneNumber' | ibeadmin | async}}</span>
							<span class="value">{{ INDRA_printPhoneNumber() }}</span>
						</div>
					</div>
					<div class="form-field--row grid no-padding">
						<div class="form-field col-12">
							<span class="label">{{'createAccountSidebar.upgrade.text.email' | ibeadmin | async}}</span>
							<span class="value">{{ userInfo?.contactEmail }}</span>
						</div>
					</div>

				</div>

				
				<div *ngIf="userCountry === 'BR' || userCountry === 'PT' || userCountry === 'US' || userCountry === 'CA' || userCountry === 'AU' || userCountry === 'AR'">
					
					<hr class="separator" aria-hidden="true">
					
					<h2 class="title-h2">{{'createAccountSidebar.upgrade.text.personalDetails' | ibeadmin | async}}</h2>

					<p class="muted bottom-gap">{{'createAccountSidebar.upgrade.text.weNeedExtraDetails' | ibeadmin | async}}</p>
				

				<div class="form-field--row grid no-padding" *ngIf="userCountry === 'BR'">
					<div class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="cpf">{{'createAccountSidebar.upgrade.text.cpf' | ibeadmin | async}}</label>
						<input class="input-text {{INDRA_hasErrorsClasses(form.controls['cpf'])}}" placeholder="{{'createAccountSidebar.upgrade.text.insertCPF' | ibeadmin | async}}" appNumberOnlypattern="\d*" size="11" maxlength="11" required formControlName="cpf" id="cpf" [attr.aria-describedby]="'cpf_errdesc'"/>
						<span aria-live="polite" class="input-error" role="alert" [attr.id]="'cpf_errdesc'" *ngIf="triedToSubmit && form.controls['cpf'].invalid">{{ INDRA_Errors(form.controls["cpf"], 'createAccountSidebar.upgrade.text.cpf' | ibeadmin | async) }}</span>
					</div>
				</div>
				<div class="form-field--row grid no-padding" *ngIf="userCountry === 'PT'">
					<div class="form-field col-6 col-tp-6 col-p-12">
						<label class="label" for="nif">{{'createAccountSidebar.upgrade.text.nif' | ibeadmin | async}}</label>
						<input class="input-text {{INDRA_hasErrorsClasses(form.controls['nif'])}}" placeholder="{{'createAccountSidebar.upgrade.text.insertNIF' | ibeadmin | async}}" appNumberOnlypattern="\d*" size="9" maxlength="9" required formControlName="nif" id="nif" [attr.aria-describedby]="'nif_errdesc'"/>
						<span aria-live="polite" class="input-error" role="alert" [attr.id]="'nif_errdesc'" *ngIf="triedToSubmit && form.controls['nif'].invalid">{{ INDRA_Errors(form.controls["nif"], 'createAccountSidebar.upgrade.text.nif' | ibeadmin | async) }}</span>
					</div>
				</div>
				<div class="form-field--row grid no-padding" *ngIf="userCountry === 'US' || userCountry === 'CA' || userCountry === 'BR' || userCountry === 'AU' || userCountry === 'AR'" >
					<div class="form-field col-4 col-tp-4 col-p-12">
						<label class="label" for="state">{{'createAccountSidebar.upgrade.text.stateOfResidence' | ibeadmin | async}}</label>
						<app-select-input-indra
							formControlName="state"
							[options]="stateOptions"
							[optionsTranslated]="true"
							[errorClass]="INDRA_hasErrorsClasses(form.get('state'))"
						></app-select-input-indra>
						<span aria-live="polite" class="input-error" role="alert" [attr.id]="'state_errdesc'" *ngIf="triedToSubmit && form.controls['state'].invalid">{{INDRA_Errors(form.controls["state"], 'createAccountSidebar.upgrade.text.state' | ibeadmin | async)}}</span>
					</div>
				</div>
				<p class="muted">{{'createAccountSidebar.upgrade.text.weWillUseThisInfo' | ibeadmin | async}}</p>
				</div>

				<hr class="separator" aria-hidden="true">

				<h2 class="title-h2">{{'createAccountSidebar.upgrade.text.communications' | ibeadmin | async}}</h2>

				<div class="form-field--row grid no-padding">

					<div class="form-field col-12 col-tp-12 col-p-12">
						<app-checkbox-input [id]="'communication_milesego_email'" [parentForm]="form" [formControlName]="'communication_milesego_email'" label="{{'createAccountSidebar.upgrade.text.iWantToReceiveTAPMGEmail' | ibeadmin | async}}"></app-checkbox-input>
					</div>

					<div class="form-field col-12 col-tp-12 col-p-12">
						<app-checkbox-input [id]="'communication_milesego_sms'" [parentForm]="form" [formControlName]="'communication_milesego_sms'" label="{{'createAccountSidebar.upgrade.text.iWantToReceiveTAPMGSMS' | ibeadmin | async}}"></app-checkbox-input>
					</div>


				</div>

				<hr class="separator" aria-hidden="true">

				<h2 class="title-h2">{{'createAccountSidebar.text.dateTreatmentConsent' | ibeadmin | async}}</h2>

				<div class="form-field--row grid no-padding">

					<div class="col-12 col-tp-12 col-p-12 disclaimer">
						<p class="muted bottom-gap">
							{{'createAccountSidebar.text.ifYouConsent' | ibeadmin | async}}
						</p>
						<p class="muted bottom-gap top-gap">
							{{'createAccountSidebar.text.yourProfileWillBeCreated' | ibeadmin | async}}
						</p>
						<p class="muted bottom-gap top-gap">
							{{'createAccountSidebar.text.forMoreInfo' | ibeadmin | async}}
						</p>

						<p class="bottom-gap top-gap">
							{{'createAccountSidebar.text.iAcceptTheTreatment' | ibeadmin | async}}
						</p>

						<div class="radios-group">
							<fieldset>
								<div class="radio">
									<label class="radio__label" for="treatment_consent-yes">{{'createAccountSidebar.text.yes' | ibeadmin | async}}</label>
									<input class="radio__input" value='yes' id="treatment_consent-yes" name="treatment_consent" type="radio" required formControlName="treatment_consent" [attr.aria-describedby]="'consents_errdesc'">
									<div class="radio__bullet"></div>
								</div>
								<div class="radio">
									<label class="radio__label" for="treatment_consent-no">{{'createAccountSidebar.text.no' | ibeadmin | async}}</label>
									<input class="radio__input" value='no' id="treatment_consent-no" name="treatment_consent" type="radio" required formControlName="treatment_consent" [attr.aria-describedby]="'consents_errdesc'">
									<div tabindex="0" class="radio__bullet"></div>
								</div>
							</fieldset>
						</div>

						<div class="form-field">
							<span aria-live="polite" class="input-error no-margin" role="alert" [attr.id]="'consents_errdesc'" *ngIf="form.controls['treatment_consent'].invalid && triedToSubmit">{{ INDRA_Errors(form.controls['treatment_consent'], 'createAccountSidebar.text.dateTreatmentConsent' | ibeadmin | async) }}</span>
						</div>

					</div>
				</div>

				<hr class="separator" aria-hidden="true">

				<h2 class="title-h2">{{'createAccountSidebar.text.termsAndCondition' | ibeadmin | async}}</h2>

				<div class="form-field--row grid no-padding terms">
					<div class="form-field col-12 col-tp-12 col-p-12">
						<app-checkbox-input [id]="'terms_conditions'" [parentForm]="form" [formControlName]="'terms_conditions'" label="{{'createAccountSidebar.text.iHaveReadAndAccept' | ibeadmin | async}}"></app-checkbox-input>
						<span aria-live="polite" class="input-error" role="alert" [attr.id]="'terms_conditions_errdesc'" *ngIf="form.controls['terms_conditions'].invalid && triedToSubmit">{{ INDRA_Errors(form.controls['terms_conditions'], 'createAccountSidebar.text.termsAndCondition' | ibeadmin | async) }}</span>
					</div>
				</div>

			</form>

			<div class="top-gap--extra">
				<button class="button side-button full-width" (click)="INDRA_saveSidebar()" [attr.aria-label]="'createAccountSidebar.upgrade.aria.submitForm' | ibeadmin | async">{{'createAccountSidebar.text.signUpForTAPMG' | ibeadmin | async}}</button>
				<button class="link side-button full-width top-gap" (click)="INDRA_closeSidebar()" [attr.aria-label]="'createAccountSidebar.upgrade.aria.closeDialog' | ibeadmin | async">{{'createAccountSidebar.text.cancel' | ibeadmin | async}}</button>
			</div>
		</div>

	</div>
</ng-container>
